import React, { FC } from 'react';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { useSettings } from '@wix/tpa-settings/react';

import { Experiment, FieldSection } from '../../../../../types';
import { useFormFields } from '../../../../../contexts/form';
import settingsParams from '../../../settingsParams';
import { SectionHeader } from '../../common/SectionHeader';
import { FieldGroup } from '../../FieldGroup';
import { LoginEmail } from './LoginEmail';
import { classes } from './Account.st.css';

export const Account: FC = () => {
  const fields = useFormFields();
  const settings = useSettings();
  const { experiments } = useExperiments();

  return (
    <div className={classes.root}>
      <SectionHeader
        title={settings.get(settingsParams.accountSectionTitle)}
        subtitle={settings.get(settingsParams.accountSectionSubtitle)}
      />
      {!experiments.enabled(Experiment.ChangeLoginInfo) && <LoginEmail />}
      <FieldGroup fields={fields} section={FieldSection.GENERAL} />
    </div>
  );
};
